import {
    validators,
    checkNumberList,
    checkEmailList,
} from '../../utils/validators';
import { isEmpty } from 'lodash';

const validate = values => {
    const { REQUIRE } = validators;
    const errors = {};
    const productDetailsErrors = [];

    const isMultiProductLink =
        values &&
        values.multiProductLink &&
        values.multiProductLink.length &&
        values.multiProductLink.includes('multiProductLink');

    if (REQUIRE(values.linkName)) {
        errors.linkName = 'Please enter a link name';
    } else if (REQUIRE(values.linkId)) {
        errors.linkId = 'Please enter a link Id';
    } else if (!isMultiProductLink && REQUIRE(values.amount)) {
        errors.amount = 'Please enter a amount';
    } else if (!isMultiProductLink && Number(values.amount) < 1) {
        errors.amount = 'Please enter amount greater than 0';
    } else if (REQUIRE(values.validity)) {
        errors.validity = 'Please select a validity';
    } else if (REQUIRE(values.remarks)) {
        errors.remarks = 'Please enter a remark';
    } else if (
        !isEmpty(values.shareValue) &&
        isEmpty(values.sharebysms) &&
        isEmpty(values.sharebyemail)
    ) {
        errors.sharebyemail = 'Please enter the Emails and Phone Numbers';
    }

    if (checkNumberList(values.sharebysms)) {
        errors.sharebysms = 'Please enter valid mobile numbers';
    }
    if (checkEmailList(values.sharebyemail)) {
        errors.sharebyemail = 'Please enter valid emails';
    }
    if (
        values &&
        values.multiProductLink &&
        values.multiProductLink.length &&
        values.multiProductLink.includes('multiProductLink') &&
        values.productInfo &&
        values.productInfo.length
    ) {
        values.productInfo.forEach((product, productIndex) => {
            const productError = {};

            if (!product || REQUIRE(product.name)) {
                productError.name = 'Please enter name';
            }

            if (!product || REQUIRE(product.amount)) {
                productError.amount = 'Please enter amount';
            }

            if (product && parseInt(product.amount, 10) < 0) {
                productError.amount = 'Amount cannot be negative';
            }

            if (Object.keys(productError).length) {
                productDetailsErrors[productIndex] = productError;
            }
        });
    }

    if (productDetailsErrors.length) {
        errors.productInfo = productDetailsErrors;
    }

    return errors;
};

export default validate;
